import type { RateInfo } from '../../types/electricity'
import { useCountdown } from '../../hooks/useCountdown'
import { useLanguage } from '../../i18n/LanguageContext'

function pad(n: number): string {
  return n.toString().padStart(2, '0')
}

export function CountdownTimer({ rate }: { rate: RateInfo }) {
  const { hours, minutes, seconds } = useCountdown(rate.nextChange)
  const { t } = useLanguage()

  const isOffpeak = rate.tier === 'offpeak'
  const label = isOffpeak
    ? t('countdown.expensiveIn') as string
    : t('countdown.cheapIn') as string
  const labelColor = isOffpeak ? 'text-amber-400' : 'text-emerald-400'

  return (
    <div className="text-center mt-4">
      <p className={`text-sm mb-2 font-bold ${labelColor}`}>
        {label}
      </p>
      <div className="flex justify-center gap-2" dir="ltr">
        <TimeUnit value={pad(hours)} label={t('countdown.hours') as string} />
        <span className="text-xl font-heading text-slate-500 mt-0.5">:</span>
        <TimeUnit value={pad(minutes)} label={t('countdown.minutes') as string} />
        <span className="text-xl font-heading text-slate-500 mt-0.5">:</span>
        <TimeUnit value={pad(seconds)} label={t('countdown.seconds') as string} />
      </div>
    </div>
  )
}

function TimeUnit({ value, label }: { value: string; label: string }) {
  return (
    <div className="flex flex-col items-center">
      <span className="font-heading text-2xl font-bold text-white tabular-nums">
        {value}
      </span>
      <span className="text-[10px] text-slate-500 mt-0.5">{label}</span>
    </div>
  )
}
